module.exports = __webpack_public_path__ + "assets/imgs/map@1.5x.8645767ddd4171c28d46296057d55a0b.png";